import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

function Pagination() {
    this.defaultAttrs({
        'page-button': '[data-page-number]',
    });

    this.after('initialize', function() {
        this.on('click', {
            'page-button': this.changePage,
        });

        this.on(document, 'dataPaginationUpdate', this.updatePagination);
    });

    this.changePage = function(event, data) {
        event.preventDefault();
        $(document).trigger('uiPaginationChangePage', {
            page: $(data.el).attr('data-page-number'),
        });
    };

    this.updatePagination = function(event, data) {
        this.$node.html(data.pagination);
        window.scrollTo(0, 0);
    };
}

export default defineComponent(Pagination);



// WEBPACK FOOTER //
// ./src/js/component_ui/pagination.js